import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import FgPass from '../Pages/public/FgPass';
import VerifyPage from '../Pages/public/VerifyPage';
import SignIn from '../Pages/public/SignIn';
import SignUp from '../Pages/public/SignUp';
import SecurityLayout from '../Pages/layout/SecurityLayout';
import Verify from '../Security/Verify';
import ResetPassword from '../Pages/public/ResetPassword';

const SecurityRoute = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route element={<SecurityLayout/>}>
                    <Route path="/sec/log-in" element={<SignIn />} />
                    <Route path="/sec/create-account" element={<SignUp />} />
                    <Route path="/sec/forgot-password" element={<FgPass />} />
                    <Route path="/sec/verify" element={<VerifyPage />} />
                    <Route path="/sec/verify/:token" element={<Verify/>}/>
                    <Route path="/sec/reset-password/:token" element={<ResetPassword />} />
                </Route>
            </Routes>
        </React.Fragment>
    )
}

export default SecurityRoute